import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import BinController from '../business/bin-cotroller';
import {getConfig} from '../config';
import sleep from '../util/sleep';
import {BIN_LABEL_STYLES, BIN_ON_DURATION_MS, COLOR_MAP} from '../util/constant';
import {sortAlphaNumeric} from "../../../../util/Util";

const INITIAL_STATE = {
    isAutoButtonPressed: false,
    colorByBin: new Map(),
    queryMap: {}
};

const BIN_BUTTON_STYLE = {
    minWidth: '65px',
    maxWidth: '80px',
    minHeight: '50px',
    textShadow: '-1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF',
    color: '#000000'
};
const BIN_BUTTON_CLASS_NAME = 'p-0';
const OV_BUTTON_STYLE = {
    minWidth: '100px',
    maxWidth: '125px',
    minHeight: '60px',
    textShadow: '-1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, 1px 1px 0 #FFFFFF',
    color: '#000000'
};
const OV_BUTTON_CLASS_NAME = 'p-0';
const GREY_RGB_COLOR = '#DDDDDD';
const RANDOM_COLOR_NAME = 'RANDOM';
const COLOR_NAMES = [RANDOM_COLOR_NAME, ...Object.keys(COLOR_MAP)];
const DEFAULT_COLOR_NAME = RANDOM_COLOR_NAME;
const QUERY_PARAMETERS = {
    color: 'color',
    aisle: 'aisle'
};

class BinTesterWithSiteConfig extends React.Component {
    constructor(props) {
        super(props);
        this.config = getConfig();
        this.state = Object.assign({color: 'RANDOM'}, INITIAL_STATE);
        this.isAutoRunning = false;
        //this.verifyQueryParametersAndRedirect();
        this.initializeBinController();
    }

    componentDidUpdate(prevProps) {
        //this.verifyQueryParametersAndRedirect();
        if (this.props.siteId !== prevProps.siteId) {
            this.setState(INITIAL_STATE);
            this.isAutoRunning = false;
            //this.setQueryParameter(QUERY_PARAMETERS.aisle, undefined);
            const map = this.state.queryMap;
            map[QUERY_PARAMETERS.aisle] = undefined;
            this.setState({queryMap: map});
            return;
        }

        // if site config becomes available or when site config is available and color or aisle changes, re-create bin controller
        const validAisles = BinTesterWithSiteConfig.getAisles(this.props);
        const color = this.getColor(this.props);
        const aisle = this.getAisle(this.props);
        const prevValidAisles = BinTesterWithSiteConfig.getAisles(prevProps);
        const prevColor = this.getColor(prevProps);
        const prevAisle = this.getAisle(prevProps);

        if (validAisles !== prevValidAisles || color !== prevColor || aisle !== prevAisle) {
            this.initializeBinController();
        }
    }

     getAisle() {
        // parse query param and get aisle
        return this.state.queryMap[QUERY_PARAMETERS.aisle] ? this.state.queryMap[QUERY_PARAMETERS.aisle] : null;
    }

     getColor() {
        return this.state.queryMap[QUERY_PARAMETERS.color] ? this.state.queryMap[QUERY_PARAMETERS.color] : DEFAULT_COLOR_NAME;
    }

    static getAisles(props) {
        const binConfig = BinTesterWithSiteConfig.getBinsByAisleConfig(props);
        return binConfig == null ? null : sortAlphaNumeric(Object.keys(binConfig));
    }

    static getBinsByAisleConfig(props) {
        if (props.siteConfig.status === 200 && props.siteConfig.data.binConfig != null) {
            return props.siteConfig.data.binConfig.binsByAisle;
        }
        return null;
    }

    // Temp solution for IN SC use case
    static getBinLabelStyle(props, defaultType) {
        if (props.siteConfig.status === 200 && props.siteConfig.data.binLabelStyle != null) {
            return props.siteConfig.data.binLabelStyle;
        }
        return defaultType;
    }

    // Temp solution for IN SC use case
    static getRackType(props) {
        if (props.siteConfig.status === 200 && props.siteConfig.data.rackType != null) {
            return props.siteConfig.data.rackType;
        }
        return {Row: 2, Column: 3};
    }

    initializeBinController() {
        const validAisles = BinTesterWithSiteConfig.getAisles(this.props);
        const color = this.getColor(this.props);
        const aisle = this.getAisle(this.props);
        const binLabelStyle = BinTesterWithSiteConfig.getBinLabelStyle(this.props, this.config.binLabelStyle);
        if (validAisles != null && aisle != null && color != null) {
            this.binController = new BinController(this.props.siteId, color, aisle, binLabelStyle);
        } else {
            this.binController = null;
        }
    }

    verifyQueryParametersAndRedirect() {
        const color = this.getColor(this.props);
        const aisle = this.getAisle(this.props);
        const validAisles = BinTesterWithSiteConfig.getAisles(this.props);
        const map = this.state.queryMap;

        if (!COLOR_NAMES.includes(color)) {
            map[QUERY_PARAMETERS.color] = DEFAULT_COLOR_NAME;
            this.setState({queryMap: map});
        }
        if (validAisles != null && aisle != null && !validAisles.includes(aisle)) {
            map[QUERY_PARAMETERS.aisle] = undefined;
            this.setState({queryMap: map});
        }
    }

    setBinOn(bin, color) {
        const {colorByBin} = this.state;
        colorByBin.set(bin, color);
        this.setState({colorByBin});
    }

    setBinOff(bin) {
        const {colorByBin} = this.state;
        colorByBin.delete(bin);
        this.setState({colorByBin});
    }

    async blinkBin(bin) {
        const colorRgb = await this.binController.blink(bin);
        this.setBinOn(bin, `#${colorRgb}`);
        setTimeout(() => {
            this.setBinOff(bin);
        }, BIN_ON_DURATION_MS);
    }

    changeAisle(aisle) {
        this.isAutoRunning = false;
        const map = this.state.queryMap;
        map[QUERY_PARAMETERS.aisle] = aisle;
        this.setState({queryMap: map});
    }

    handleColorSelection(event) {
        const color = event.target.value;
        const map = this.state.queryMap;
        map[QUERY_PARAMETERS.color] = color;
        this.setState({queryMap: map});
    }

    handleAisleSelection(event) {
        const aisle = event.target.value === '' ? null : event.target.value;
        this.changeAisle(aisle);
    }

    handleAutoButtonClick() {
        if (!this.isAutoRunning) {
            this.startAutoRun();
        } else {
            this.stopAutoRun();
        }
    }

    async startAutoRun() {
        const aisle = this.getAisle(this.props);
        this.isAutoRunning = true;
        this.setState({isAutoButtonPressed: true});
        const bins = this.getBins();
        for (const bin of bins) {
            if (!this.isAutoRunning || this.getAisle(this.props) !== aisle) {
                return;
            }
            this.blinkBin(bin);
            await sleep(BIN_ON_DURATION_MS);
        }
        this.stopAutoRun();
    }

    stopAutoRun() {
        this.isAutoRunning = false;
        this.setState({isAutoButtonPressed: false});
    }

    getBins() {
        if (this.getAisle(this.props) != null) {
            const binConfig = BinTesterWithSiteConfig.getBinsByAisleConfig(this.props);
            const aisle = this.getAisle(this.props);
            return binConfig[aisle] ? binConfig[aisle].flat(1) : [];
        }
        return [];
    }

    getAisleIndex(aisle) {
        const aisles = BinTesterWithSiteConfig.getAisles(this.props);
        if (aisles != null) {
            const aisleIndex = aisles.indexOf(aisle);
            return aisleIndex === -1 ? null : aisleIndex;
        }
        return null;
    }

    getConnectivityByAisle() {
        const connectivityByAisle = {};
        if (this.props.siteConfig.status === 200 && this.props.siteConfig.data.controllerConfig
            && this.props.siteConfig.data.controllerConfig.ledControllers) {
            const ledControllers = this.props.siteConfig.data.controllerConfig.ledControllers;
            for (var controller in ledControllers) {
                for(var aisle of ledControllers[controller].aisles) {
                    connectivityByAisle[aisle.aisle] = aisle.isOnline;
                }
            }
            return connectivityByAisle;
        }
        return null;
    }

    isAutoReady() {
        if (this.props.siteId == null || this.getAisle(this.props) == null) {
            return false;
        } else if (!this.isAutoRunning && this.state.colorByBin.size > 0) {
            return false;
        }
        return true;
    }

    generateAisleOptions() {
        const aisles = BinTesterWithSiteConfig.getAisles(this.props);
        const aisleOptions = [<option key='' value=''>Choose an aisle</option>];
        if (aisles) {
            for (let i = 0; i < aisles.length; i += 1) {
                const aisleLabel = aisles[i];
                aisleOptions.push(<option key={aisleLabel} value={aisleLabel}>{aisleLabel}</option>);
            }
        }
        return aisleOptions;
    }

    generateColorOptions() {
        return COLOR_NAMES.map((colorName, index) => <option key={index}>{colorName}</option>);
    }

    generateConnectivityWarning() {
        const connectivityByAisle = this.getConnectivityByAisle();
        const aisleLabel = this.getAisle(this.props);
        if (aisleLabel == null) {
            return null;
        } else if (connectivityByAisle == null || connectivityByAisle[aisleLabel] == null) {
            return <Alert variant="warning">Connectivity info is not available</Alert>;
        } else if (!connectivityByAisle[aisleLabel]) {
            const {macAddress} = connectivityByAisle[aisleLabel];
            return <Alert variant="danger">{`LED controller for ${aisleLabel} is offline. Controller MAC address is ${macAddress}.`}</Alert>;
        }
        return null;
    }

    generateRacks() {
        const binConfig = BinTesterWithSiteConfig.getBinsByAisleConfig(this.props);
        const aisleLabel = this.getAisle(this.props);
        if (aisleLabel == null) {
            return {racks: <div>Select a aisle to begin</div>};
        } else if (binConfig[aisleLabel] == null) {
            return {racks: <div>Cannot find bin configuration for aisle {aisleLabel}. Please contact SBL team.</div>};
        }
        const binsForAisle = binConfig[aisleLabel];

        const binButtonRows = [];
        const {regButtons, ovButtons} = this.generateGridByLabelType(binsForAisle);
        for (let i = 0; i < regButtons.length; i += 1) {
            const buttonsInRow = regButtons[regButtons.length - i - 1];
            binButtonRows.push(<ButtonGroup key={i}>{buttonsInRow}</ButtonGroup>);
        }
        return {
            racks: <ButtonGroup vertical>{binButtonRows}</ButtonGroup>,
            ovRacks: <ButtonGroup>{ovButtons}</ButtonGroup>
        };
    }

    generateGridByLabelType(binsForAisle) {
        if (BinTesterWithSiteConfig.getBinLabelStyle(this.props) === BIN_LABEL_STYLES.IN_SC) {
            const {Row: row, Column: column} = BinTesterWithSiteConfig.getRackType(this.props);
            return this.generateGridByRack(binsForAisle, row, column);
        } else {
            const bins = binsForAisle.sort();
            return this.generateGrid(bins);
        }
    }

    // Temp solution for IN SC use case.
    generateGridByRack(bins, numOfRow, numOfCol) {
        let button;
        let maxLength;
        let buttonsInRow = [];
        const regButtons = [];

        for (const bin of bins) {
            const index = bins.indexOf(bin);
            maxLength = bins.length <= numOfCol ? numOfCol : Math.ceil(bins.length / numOfRow);
            if (index % maxLength === 0 && buttonsInRow.length > 0) {
                regButtons[numOfRow - 1 - Math.floor((index - 1) / maxLength)] = buttonsInRow;
                buttonsInRow = [];
            }
            // use oversize button instead as can have long label
            button = this.generateOversizeButton(bin);
            buttonsInRow.push(button);
        }

        if (buttonsInRow.length > 0) {
            regButtons[numOfRow - 1 - Math.floor((bins.length - 1) / maxLength)] = buttonsInRow;
        }
        for (let i = 0; i < regButtons.length; i += 1) {
            const row = regButtons[i];
            while (row && row.length < maxLength) {
                row.push(this.generateEmptyOVButton(`${i}-${row.length}`));
            }
        }
        return {regButtons};
    }

    generateGrid(bins) {
        let button;
        let rowIndex;
        let curIndex = 0;
        let buttonsInRow = [];
        const regButtons = [];
        const ovButtons = [];
        let maxLength = 0;
        for (const bin of bins) {
            if (bin.toUpperCase().startsWith('OV')) {
                button = this.generateOversizeButton(bin);
                ovButtons.push(button);
            } else {
                rowIndex = bin.split(/[.-]/).slice(-1)[0].slice(0, -1);
                if (curIndex !== rowIndex) {
                    if (buttonsInRow.length > 0) {
                        regButtons.push(buttonsInRow);
                        maxLength = maxLength < buttonsInRow.length ? buttonsInRow.length : maxLength;
                        buttonsInRow = [];
                    }
                    curIndex = rowIndex;
                }
                button = this.generateBinButton(bin);
                buttonsInRow.push(button);
            }
        }

        if (buttonsInRow.length > 0) {
            regButtons.push(buttonsInRow);
        }
        for (let i = 0; i < regButtons.length; i += 1) {
            const row = regButtons[i];
            while (row.length < maxLength) {
                row.push(this.generateEmptyButton(`${i}-${row.length}`));
            }
        }
        return {regButtons, ovButtons, maxLength};
    }

    generateEmptyButton(key) {
        return <Button className={BIN_BUTTON_CLASS_NAME}
            style={BIN_BUTTON_STYLE}
            key={key}
            variant={'link'}
            disabled></Button>;
    }

    generateEmptyOVButton(key) {
        return <Button className={OV_BUTTON_CLASS_NAME}
            style={OV_BUTTON_STYLE}
            key={key}
            variant={'link'}
            disabled></Button>;
    }

    generateBinLabelForSC(bin) {
        const lst = bin.split(new RegExp('-|_'));
        const label = lst.filter((ele) => (ele.match('^^[A-Z0-9]{4}$') && ele !== this.props.siteId));
        return label.join('_');
    }

    generateBinButton(bin) {
        const backgroundColor = this.state.colorByBin.get(bin) || GREY_RGB_COLOR;
        return <Button className={BIN_BUTTON_CLASS_NAME}
            style={{...BIN_BUTTON_STYLE, backgroundColor}}
            variant='outline-dark'
            key={bin}
            name={bin}
            onClick={() => this.blinkBin(bin)}>{bin}</Button>;
    }

    generateOversizeButton(bin) {
        const backgroundColor = this.state.colorByBin.get(bin) || GREY_RGB_COLOR;
        let label = bin;
        if (BinTesterWithSiteConfig.getBinLabelStyle(this.props) === BIN_LABEL_STYLES.IN_SC) {
            label = this.generateBinLabelForSC(bin);
        }
        return <Button className={OV_BUTTON_CLASS_NAME}
            style={{...OV_BUTTON_STYLE, backgroundColor}}
            variant='outline-dark'
            key={bin}
            name={bin}
            onClick={() => this.blinkBin(bin)}>{label}</Button>;
    }

    generateAutoButton() {
        const variant = this.state.isAutoButtonPressed ? 'danger' : 'outline-success';
        const buttonLabel = this.state.isAutoButtonPressed ? 'Stop' : 'Auto';
        return <Button className="ml-2 mr-2"
            variant={variant}
            onClick={this.handleAutoButtonClick.bind(this)}
            disabled={!this.isAutoReady()}>{buttonLabel}</Button>;
    }

    generatePrevAisleButton() {
        const aisles = BinTesterWithSiteConfig.getAisles(this.props);
        const currentAisle = this.getAisle(this.props);
        const aisleIndex = this.getAisleIndex(currentAisle);
        if (aisleIndex == null || aisleIndex === 0) {
            return <Button className="ml-2 mr-2"
                variant='link'
                disabled={true}
                active={false}></Button>;
        }
        const prevAisleIndex = aisleIndex - 1;
        const prevAisleLabel = aisles[prevAisleIndex];
        return <Button className="ml-2 mr-2"
            variant="warning"
            onClick={() => this.changeAisle(prevAisleLabel)}>{`< ${prevAisleLabel}`}</Button>;
    }

    generateNextAisleButton() {
        const aisles = BinTesterWithSiteConfig.getAisles(this.props);
        const currentAisle = this.getAisle(this.props);
        const aisleIndex = this.getAisleIndex(currentAisle);
        if (aisles != null && aisleIndex === aisles.length - 1) {
            return <Button className="ml-2 mr-2"
                variant='link'
                disabled={true}
                active={false}></Button>;
        }
        const nextAisleIndex = aisleIndex == null ? 0 : aisleIndex + 1;
        const nextAisleLabel = aisles ? aisles[nextAisleIndex] : "";
        return <Button className="ml-2 mr-2"
            variant="warning"
            onClick={() => this.changeAisle(nextAisleLabel)}>{`${nextAisleLabel} >`}</Button>;

    }

    render() {
        const {racks, ovRacks} = this.generateRacks();
        const aisle = this.getAisle(this.props);
        const aisles = this.generateAisleOptions();
        const colors = this.generateColorOptions();

        return <div>
            <Container>
                <Row className="mt-3" >
                    <Col>
                        <Form.Group controlId="color">
                            <Form.Label>Color</Form.Label>
                            <Form.Control as="select"
                                name="color"
                                value={this.getColor(this.props)}
                                onChange={this.handleColorSelection.bind(this)}
                            >
                                {colors}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="aisle">
                            <Form.Label>Aisle</Form.Label>
                            <Form.Control as="select"
                                name="aisle"
                                value={aisle == null ? '' : aisle}
                                onChange={this.handleAisleSelection.bind(this)}>
                                {aisles}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                {this.generateConnectivityWarning()}
                <Row style={{overflowX: 'auto', whiteSpace: 'nowrap'}}>
                    <Col>{racks}</Col>
                </Row>
                <Row className="justify-content-center mt-3 mb-3 p-0">
                    <Col className="m-0 p-0">
                        {ovRacks}
                    </Col>
                </Row>
                <Row className="justify-content-md-center mt-3 mb-3">
                    <Col>
                        {this.generatePrevAisleButton()}
                        {this.generateAutoButton()}
                        {this.generateNextAisleButton()}
                    </Col>
                </Row>
            </Container>
        </div>;
    }
}

export default BinTesterWithSiteConfig;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/bintester/component/bin-tester-with-site-config.jsx